// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1jgTyZfATk8aZACHdc28V3 VgZDdkBiV2Qrn6vDAdTjz _3IAyaLTSGhQMeijId6h9R7","countryCodeRadio":"_3KpvosMWFZ7kg2gRtdBZxE","areaCodeInput":"_2i_piYsT-hm1L1xY_xSHBR","sidInput":"_22_1wCPER4oLVMfXFfgCiZ","buyNumbersButton":"_2eQbNnQ-k4ZgiYzt--3t6E","manualEntryButton":"_2NboCR015576mtmXKhDH4_"};


//////////////////
// WEBPACK FOOTER
// ./src/AddPractice/Associations/phone-number-purchase-form.css
// module id = 814
// module chunks = 0